import React from 'react';
import ReactSelect from 'react-select';
import {
  arrayOf, func, string, number, oneOfType, bool
} from 'prop-types';
import { langType, withLang } from '../../i18n';
import { selectOptionType } from '../../constants/types';

const SelectComponent = ({
  options, value, placeholderKey, onChange, translate: t, dataCy, className, id, isSearchable
}) => {
  const handleChange = (selected) => onChange(selected.value);

  const selectedValue = options.filter((o) => o.value === value);

  return (
    <ReactSelect
      id={id}
      className={className}
      classNamePrefix="react-select"
      isSearchable={isSearchable}
      options={options}
      value={selectedValue}
      placeholder={t(placeholderKey)}
      onChange={handleChange}
      dataCy={dataCy}
    />
  );
};

const MultiSelectComponent = ({
  options, value, placeholderKey, onChange, translate: t, className, id, isSearchable
}) => {
  const handleChange = (selected) => onChange(selected.map((s) => s.value));

  const selectedValue = options.filter((o) => value.includes(o.value));

  return (
    <ReactSelect
      id={id}
      className={className}
      classNamePrefix="react-select"
      isMulti
      isSearchable={isSearchable}
      options={options}
      value={selectedValue}
      placeholder={t(placeholderKey)}
      onChange={handleChange}
    />
  );
};

const propTypes = {
  options: arrayOf(selectOptionType).isRequired,
  placeholderKey: string.isRequired,
  onChange: func.isRequired,
  dataCy: string,
  className: string,
  id: string,
  ...langType
};

SelectComponent.propTypes = {
  ...propTypes,
  isSearchable: bool,
  value: oneOfType([string, number, bool])
};

MultiSelectComponent.propTypes = {
  ...propTypes,
  isSearchable: bool,
  value: arrayOf(oneOfType([string, number, bool]))
};

SelectComponent.defaultProps = {
  value: undefined,
  isSearchable: false
};
MultiSelectComponent.defaultProps = {
  value: [],
  isSearchable: false
};

export const Select = withLang(SelectComponent);
export const MultiSelect = withLang(MultiSelectComponent);
